export * from './lib/dialog.module';

export { AccredibleConfirmDialogComponent } from './lib/confirm-dialog/confirm-dialog.component';
export { AccredibleConfirmDialogComponentModule } from './lib/confirm-dialog/confirm-dialog.component.module';
export { AccredibleConfirmDialogData } from './lib/confirm-dialog/models/confirm-dialog.model';
export { AccredibleDialogTemplateComponentModule } from './lib/dialog-template/dialog-template.component.module';
export { AccredibleDialogService } from './lib/service/dialog.service';
